
export class WeeklyReservationsModelDTO {
  constructor (
    public venueId?: string,
    public isMondayFirst?: boolean,
  ) {}
}
export class WeeklyReservationsRequestDTO {
  constructor (
    public venueId?: string,
    public isMondayFirst?: boolean,
  ) {}
}

